import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ResizeService } from 'src/app/shared/resize.service';
import { AuthService } from '../auth.service';
import { EMAIL_PATTERN } from 'src/app/shared/common';

@Component({
  selector: 'app-forogt-password',
  templateUrl: './forogt-password.component.html',
  styleUrls: ['./forogt-password.component.scss'],
  standalone: false,
})
export class ForogtPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  screenType!: string;
  isLoading$: Observable<boolean> | undefined;
  error: string | undefined;
  success: boolean = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private resizeService: ResizeService
  ) {
    this.isLoading$ = this.authService.isLoading$;
    this.resizeService.screenWidthChange$.subscribe({
      next: (res: string) => {
        this.screenType = res;
      },
    });
  }
  ngOnInit(): void {
    this.initForm();
  }
  initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.email, Validators.pattern(EMAIL_PATTERN)]],
    });
  }
  sendEmailForReset() {
    this.authService.forgetPassword(this.forgotPasswordForm.value['email']).subscribe({
      next: () => {
        this.success = true;
      },
      error: (err) => {
        if (err.message) this.error = err.message;
        console.warn('Somethig went wrong..');
      },
    });
  }
}
